import Stripe from "stripe";

export function getStripe(): Stripe {
  let _stripe: Stripe | null = null;
  if (!_stripe) {
    _stripe = new Stripe(process.env.STRIPE_SECRET_KEY || "placeholder", {
      apiVersion: "2025-07-30.basil",
    });
  }
  return _stripe;
}